import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { modalOpen, modalClose } from '@/store/ui/actions';
import { get } from '@/utils/helpers';

export const useModals = (id = '') => {
  const dispatch = useDispatch();
  const params = useSelector(
    (state) => get(state, ['ui', 'params', id]),
    shallowEqual
  );

  return {
    params,
    modalOpen: (id, param) => dispatch(modalOpen(id, param)),
    modalClose: (id) => dispatch(modalClose(id)),
  };
};
